import React from 'react';
import ProductSearchResultsContainer from './ProductSearchResultsContainer';
import ProductSearchResultsNonFound from './ProductSearchResultsNonFound';
import PropTypes from 'prop-types';

const ProductSearchResults = ({
    products,
    attributes, 
    categoryName,
    showMoreFacets,
    expandedFacets,
    promotionalArea,
    categoryImageUrl,
    translationUtility,
    paginationViewModel,
    categoryDescription,
    recommendedProducts,
    categoryImageAltText,
    addToCart,
    onResultClick,
    onAttributeChange, 
    onClearAttributes, 
    onToggleShowMoreFacet,
    onCurrentSortByChange,
    onToggleFacetExpanded,
    onCurrentPageIndexChange, 
    onShowMobileFacetsChange,
    onCurrentItemsPerPageChange, 
}) => {
    return (
        <div>
            {products.length > 0 ? 
                <ProductSearchResultsContainer 
                    attributes={attributes}
                    onAttributeChange={onAttributeChange} 
                    onClearAttributes={onClearAttributes} 
                    paginationViewModel={paginationViewModel}
                    onCurrentItemsPerPageChange={onCurrentItemsPerPageChange} 
                    onCurrentSortByChange={onCurrentSortByChange}
                    onCurrentPageIndexChange={onCurrentPageIndexChange} 
                    products={products}
                    recommendedProducts={recommendedProducts}
                    onResultClick={onResultClick}
                    onShowMobileFacetsChange={onShowMobileFacetsChange}
                    expandedFacets={expandedFacets}
                    onToggleFacetExpanded={onToggleFacetExpanded}
                    categoryName={categoryName}
                    categoryImageUrl={categoryImageUrl}
                    categoryImageAltText={categoryImageAltText}
                    categoryDescription={categoryDescription}
                    translationUtility={translationUtility}
                    showMoreFacets={showMoreFacets}
                    onToggleShowMoreFacet={onToggleShowMoreFacet}
                    promotionalArea={promotionalArea}
                    addToCart={addToCart}
                />
            : <ProductSearchResultsNonFound text={translationUtility.translateResourceString("/Search/NoProductResults")} />
            }
        </div>
    );
};

ProductSearchResults.propType = {
    attributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        DisplayName: PropTypes.string,
        Values: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string,
            Checked: PropTypes.bool,
            Count: PropTypes.number
        }))
    })),
    onAttributeChange: PropTypes.func, 
    onClearAttributes: PropTypes.func, 
    paginationViewModel: PropTypes.shape({
        ResultsTotal: PropTypes.number,
        CurrentItemsPerPage: PropTypes.number,
        CurrentPageIndex: PropTypes.number,
        CurrentSortBy: PropTypes.string,
        CurrentItemsOnPage: PropTypes.number
    }),
    onCurrentItemsPerPageChange: PropTypes.func, 
    onCurrentSortByChange: PropTypes.func,
    onCurrentPageIndexChange: PropTypes.func, 
    products: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        Url: PropTypes.string,
        Image: PropTypes.shape({
            Url: PropTypes.string,
            Alt: PropTypes.string
        }),
        Description: PropTypes.string,
        IsRestricted: PropTypes.bool
    })),
    recommendedProducts: PropTypes.arrayOf(PropTypes.shape({
        RecommendationId: PropTypes.number,
        Name: PropTypes.string,
        Url: PropTypes.string,
        Image: PropTypes.shape({
            Url: PropTypes.string,
            Alt: PropTypes.string
        }),
        Description: PropTypes.string,
        IsRestricted: PropTypes.bool
    })),
    expandedFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleFacetExpanded: PropTypes.func,
    translationUtility: PropTypes.shape({
        translateResourceString: PropTypes.func
    }),
    showMoreFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleShowMoreFacet: PropTypes.func,
    promotionalArea: PropTypes.string
};

export default ProductSearchResults;


// WEBPACK FOOTER //
// ./src/Components/search/Features/Products/ProductSearchResults.jsx